import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import Prompt from "components/UpStyled/Prompt";
import { nanoid } from "nanoid";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

var deepEqual = require("deep-equal");
const labelProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

const VersionDialog = ({
  versionsArg,
  dataArg,
  saveFunc,
  versionDialogVisible,
  setVersionDialogVisible,
}) => {
  const [newTitile, setNewTitle] = useState("");
  const [versions, setVersions] = useState(versionsArg ?? []);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [selectDialogVisible, setSelectDialogVisible] = useState(false);

  useEffect(() => {
    if (versionsArg) {
      setVersions(versionsArg);
    }
  }, [versionsArg]);

  const RenderVersionMenu = ({ version }) => {
    const [openMenu, setOpenMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setOpenMenu(true);
      event.stopPropagation();
      event.preventDefault();
    };
    const handleClose = (event) => {
      setAnchorEl(null);
      setOpenMenu(false);
      event.stopPropagation();
      event.preventDefault();
    };

    return (
      <>
        <Tooltip title="Options" placement="top-start">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={openMenu ? "version-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openMenu ? "true" : undefined}
          >
            <MoreVertIcon
              fontSize="small"
              color="inherit"
              className="border-none hover:bg-transparent"
            />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          id="version-menu"
          open={openMenu}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={labelProps}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              const newDatas = versions.map((v) => {
                if (version.id == v.id) return { ...v, editing: true };
                else return v;
              });
              setVersions(newDatas);
            }}
          >
            <EditIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Edit Name</SuiTypography>
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              setSelectedVersion(version);
              setDeleteDialogVisible(true);
            }}
          >
            <DeleteIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Delete</SuiTypography>
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              setSelectedVersion(version);
              setSelectDialogVisible(true);
            }}
          >
            <SwapVertIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Load</SuiTypography>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const saveVersion = async (newVersions) => {
    setVersions(newVersions);
    saveFunc(newVersions);
  };

  const selectVersion = async () => {
    var needBackup = true;
    for (var v of versions) {
      if (deepEqual(v.data, dataArg)) {
        needBackup = false;
        break;
      }
    }
    try {
      var newVersions = needBackup
        ? [
          {
            id: nanoid(),
            name: "Backup Copy",
            ts: new Date().toLocaleString(),
            data: JSON.parse(JSON.stringify(dataArg)),
          },
          ...versions,
        ]
        : versions;
      saveFunc(newVersions, JSON.parse(JSON.stringify(selectedVersion.data)));
    } catch (e) {
      console.log(e);
      toast.error("Save versions failed!");
    }
  };

  const createVersion = async () => {
    if (newTitile === "") {
      toast.error("Please provide a valid version name!");
      return;
    }
    setNewTitle("");
    var newVersions = [
      {
        id: nanoid(),
        name: newTitile,
        ts: new Date().toLocaleString(),
        data: JSON.parse(JSON.stringify(dataArg)),
      },
      ...versions,
    ];
    saveVersion(newVersions);
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "720px",
            height: "700px",
          },
        },
      }}
      open={versionDialogVisible}
      maxWidth={"lg"}
      onClose={() => setVersionDialogVisible(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Prompt
        heading={"Delete Confirmation"}
        text={`Are you sure you want to delete version "${selectedVersion?.name}" at ${selectedVersion?.ts}?`}
        visible={deleteDialogVisible}
        okText={"Delete"}
        okColor="dark"
        handleOk={() => {
          var newVersions = versions.filter((v) => v.id !== selectedVersion.id);
          saveVersion(newVersions);
          setDeleteDialogVisible(false);
        }}
        handleClose={() => setDeleteDialogVisible(false)}
      />
      <Prompt
        heading={"Load Version Confirmation"}
        text={`Are you sure you want to select version "${selectedVersion?.name}" at ${selectedVersion?.ts}? We will automatically create backup version if necessary.`}
        visible={selectDialogVisible}
        okText={"Load"}
        okColor="dark"
        handleOk={() => {
          setSelectDialogVisible(false);
          setVersionDialogVisible(false);
          selectVersion();
        }}
        handleClose={() => setSelectDialogVisible(false)}
      />
      <DialogTitle id="alert-dialog-title">
        Version Control
        <IconButton
          aria-label="close"
          onClick={() => setVersionDialogVisible(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <SuiBox
          sx={{ width: "100%", my: 1 }}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <SuiBox sx={{ width: "500px" }} display="flex" alignItems="center">
            <SuiTypography sx={{ width: "150px" }}>New Version:</SuiTypography>
            <SuiInput
              value={newTitile}
              onChange={(e) => {
                setNewTitle(e.target.value);
              }}
            />
          </SuiBox>
          <SuiButton
            onClick={() => {
              createVersion();
            }}
            color={"secondary"}
            variant="gradient"
          >
            Create
          </SuiButton>
        </SuiBox>
        {versions.map((version) => (
          <SuiBox
            key={version.id}
            className={`flex items-center w-full my-2 border-l-4 border-gray-100}`}
          >
            <div className="w-full h-[40px] flex items-center">
              {version.editing && (
                <SuiBox sx={{ width: "350px" }}>
                  <SuiInput
                    autoFocus
                    size="small"
                    defaultValue={version.name}
                    onKeyUp={(event) => {
                      // console.log('event', event)
                      if (event.key === "Enter") {
                        const newDatas = versions.map((v) => {
                          if (v.id == version.id)
                            return { ...v, editing: false, name: event.target.value };
                          else return v;
                        });
                        if (version.name !== event.target.value) saveVersion(newDatas);
                        else setVersions(newDatas);
                      }
                      if (event.key === "Escape") {
                        const newDatas = versions.map((v) => {
                          if (v.id == version.id) return { ...v, editing: false };
                          else return v;
                        });
                        setVersions(newDatas);
                      }
                      event.stopPropagation();
                    }}
                    onBlur={(event) => {
                      const newDatas = versions.map((v) => {
                        if (v.id == version.id)
                          return { ...v, editing: false, name: event.target.value };
                        else return v;
                      });
                      if (version.name !== event.target.value) saveVersion(newDatas);
                      else setVersions(newDatas);
                    }}
                  />
                </SuiBox>
              )}
              {!version.editing && (
                <div className="flex w-full justify-between items-center">
                  <SuiBox className={`hover:cursor-pointer`}
                    onClick={() => {
                      setSelectedVersion(version);
                      setSelectDialogVisible(true);
                    }}>
                    <SuiTypography
                      variant="button"
                      className={`ml-0 text-gray-600`}
                      lineHeight="1"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "1",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {version.name}
                    </SuiTypography>
                    <SuiTypography
                      variant="caption"
                      className={`ml-0 text-gray-600`}
                      lineHeight="1"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "1",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {version.ts}
                    </SuiTypography>
                  </SuiBox>
                  <div>
                    <RenderVersionMenu version={version} />
                  </div>
                </div>
              )}
            </div>
          </SuiBox>
        ))}
      </DialogContent>
      <DialogActions>
        <SuiButton
          onClick={() => setVersionDialogVisible(false)}
          color={"secondary"}
          variant="gradient"
        >
          Close
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default VersionDialog;
